import { Section, Eyebrow } from "@/components/site/Layout";
import { Check } from "lucide-react";

const WHATSAPP_URL =
  "https://wa.me/919888066671?text=Hi%20Aditya%2C%20I%27d%20like%20to%20learn%20more%20about%20PageOne%20Lawyers%20SEO%20for%20my%20firm.";

const ADITYA_PHOTO =
  "/__l5e/assets-v1/49542b44-d142-44e5-b009-d029a898f033/aditya-chauhan.png";

export function TalkToStrategist() {
  return (
    <div className="border-y border-border bg-secondary/40">
      <Section>
        <div className="grid items-center gap-12 lg:grid-cols-2">
          {/* Left: copy */}
          <div>
            <p className="inline-flex items-center gap-2 rounded-full border border-border bg-card px-4 py-1.5 text-xs font-semibold text-foreground">
              <span className="relative flex h-2.5 w-2.5">
                <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-green-500 opacity-60" />
                <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-green-500" />
              </span>
              Team online right now
            </p>
            <div className="mt-6">
              <Eyebrow>Direct access</Eyebrow>
            </div>
            <h2 className="mt-4 font-display text-4xl font-semibold text-foreground md:text-5xl">
              Talk to our senior strategist directly.
            </h2>
            <p className="mt-5 max-w-xl text-lg leading-relaxed text-muted-foreground">
              No forms. No gatekeepers. Message Aditya on WhatsApp and get a real
              answer about your firm's search visibility, usually within minutes.
            </p>
            <ul className="mt-8 space-y-4">
              {[
                "Straight answers on rankings, timelines, and cost",
                "A quick look at what's holding your site back",
                "No sales pitch, no obligation",
                "Bar-compliant advice from a legal-only SEO team",
              ].map((t) => (
                <li key={t} className="flex items-start gap-3">
                  <span className="mt-0.5 flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-[var(--gold)] text-[var(--navy-deep)]">
                    <Check className="h-3.5 w-3.5" strokeWidth={3} />
                  </span>
                  <span className="text-foreground">{t}</span>
                </li>
              ))}
            </ul>
            <div className="mt-10 flex flex-wrap gap-x-10 gap-y-6 border-t border-border pt-8">
              {[
                ["4.9★", "127 client reviews"],
                ["12+ yrs", "Legal-only SEO"],
              ].map(([n, l]) => (
                <div key={l}>
                  <div className="font-display text-2xl font-semibold text-[var(--gold-deep)] sm:text-3xl">
                    {n}
                  </div>
                  <div className="mt-1 text-xs text-muted-foreground sm:text-sm">{l}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Right: person card */}
          <div className="space-y-5">
            <div className="rounded-2xl border border-border bg-card p-6 shadow-[var(--shadow-card)] sm:p-8">
              <div className="flex items-center gap-5">
                <div className="relative flex-shrink-0">
                  <img
                    src={ADITYA_PHOTO}
                    alt="Aditya Chauhan, Head of SEO at PageOne Lawyers"
                    width={96}
                    height={96}
                    loading="lazy"
                    className="h-20 w-20 rounded-full border-2 border-[var(--gold)]/50 object-cover sm:h-24 sm:w-24"
                  />
                  <span
                    className="absolute bottom-1 right-1 h-4 w-4 rounded-full border-2 border-card bg-green-500"
                    aria-label="Online"
                  />
                </div>
                <div>
                  <div className="font-display text-xl font-semibold text-foreground sm:text-2xl">
                    Aditya Chauhan
                  </div>
                  <div className="text-sm font-medium text-[var(--gold-deep)]">
                    Head of SEO, PageOne Lawyers
                  </div>
                  <div className="mt-1 text-xs text-muted-foreground sm:text-sm">
                    Online, usually replies in minutes
                  </div>
                </div>
              </div>
              <p className="mt-5 text-sm leading-relaxed text-muted-foreground">
                Search programs for law firms across personal injury, DUI, family,
                and criminal defense. Ask anything, strategy, pricing, or a
                second opinion on your current agency.
              </p>
              <a
                href={WHATSAPP_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="mt-6 flex w-full items-center justify-center gap-2 rounded-lg bg-[#25D366] px-6 py-3.5 text-sm font-bold text-white transition hover:brightness-95"
              >
                <svg viewBox="0 0 24 24" className="h-5 w-5 fill-current" aria-hidden="true">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413Z" />
                </svg>
                Chat on WhatsApp
              </a>
            </div>

            <div className="flex flex-col items-center gap-4 rounded-2xl border-2 border-dashed border-[var(--gold)]/60 bg-card/60 p-6 text-center sm:flex-row sm:text-left">
              <div className="flex-1">
                <div className="font-semibold text-foreground">Prefer a call?</div>
                <p className="mt-1 text-sm text-muted-foreground">
                  Book a free 20-min strategy session.
                </p>
              </div>
              <a
                href="https://calendar.app.google/gqBLsanJBhuNAAB6A"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex flex-shrink-0 items-center gap-2 rounded-lg bg-[var(--gold)] px-6 py-3 text-sm font-bold text-[var(--navy-deep)] transition hover:brightness-105"
              >
                Pick a time <span aria-hidden="true">→</span>
              </a>
            </div>
          </div>
        </div>
      </Section>
    </div>
  );
}
